import Divider from '@mui/material/Divider';
import { styled } from '@mui/system';

export const DividerStyled = styled(Divider)(({ theme, orientation, variant }) => ({
  width: orientation === 'horizontal' ? '100%' : '',
  borderColor: variant === 'secondary' ? theme.palette.common.white : theme.palette.common.black,
}));
